import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { styled } from '@mui/system';
export default function DoubleAccordion({ data }) {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
        '& .MuiAccordionSummary-content > .accordionCustom': {
            paddingBottom: '23px',
        },
        '.Mui-expanded .accordionCustom': {
            paddingBottom: '14px !important',
        },
        '& .MuiAccordionSummary-content': {
            marginTop: '0  !important',
            marginBottom: '0 !important'
        }
    }));
    return (
        <Box>
            {data.map((item, index) => (
                <Accordion
                    key={index}
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    sx={{
                        '.MuiButtonBase-root': {
                            padding: 0,
                        },
                        '.MuiAccordionDetails-root': {
                            paddingX: 0,
                            paddingBottom: '31px !important'
                        },
                        marginBottom: '0 !important',
                        boxShadow: 0,
                        borderTop: 'solid 1px #e4e3e2',
                        borderBottom: index === data.length - 1 ? 'solid 1px #e4e3e2' : 'none',
                    }}
                >
                    <StyledAccordionSummary expandIcon={expanded === index ? <RemoveIcon /> : <AddIcon />} aria-controls={`panel${index}-content`} id={`panel${index}-header`}>
                        <Typography component="span" className="accordionCustom" fontSize={'1.5rem'} color="text.secondary" fontWeight={'600'} paddingTop={'22px'}>
                            {item.title}
                        </Typography>
                    </StyledAccordionSummary>
                    <AccordionDetails sx={{ marginTop: 0, paddingTop: 0, paddingBottom: '21px !important' }}>
                        <Grid container spacing={4}>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Typography component="span" className="accordionCustom" fontSize={'1.125rem'} color="#000" paddingTop={'22px'}>
                                    {item.content}
                                </Typography>
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Typography component="span" className="accordionCustom" fontSize={'1.125rem'} color="#000" paddingTop={'22px'}>
                                    {item.content2}
                                </Typography>
                            </Grid>

                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
}